import React, { Component } from "react";

import {
  Table,
  Button,
  Divider,
  Card,
  Form,
  Input,
  Modal,
  message,
  Select
} from "antd";

import api from "../../services/api";

export default class ContaHDI extends Component {
  state = {
    tableLoading: true,
    dataSource: [],
    total: 0
  };

  page = 1;
  search = "";

  componentDidMount = async () => {
    let data = await this.getPessoas("");
    let dataSource = this.handleAPIResponse(data);
    this.setState({
      tableLoading: false,
      dataSource: dataSource,
      total: data.data.count
    });
  };

  getPessoas = async () => {
    try {
      let res = await api(`/conta-hdi/`);
      return res;
    } catch (err) {
      window.alert("erro");
    }
  };

  handleAPIResponse = res => {
    let dataSource = [];

    res.data.forEach((defaultValue, index) => {
      dataSource.push({
        id: defaultValue.id,
        username: defaultValue.username,
        password: defaultValue.password,
        tipo_conta: defaultValue.tipo_conta,
        key: index
      });
    });
    return dataSource;
  };

  columns = [
    {
      title: "Username",
      dataIndex: "username",
      key: "username"
    },
    {
      title: "password",
      dataIndex: "password",
      key: "password"
    },
    {
      title: "Tipo da conta",
      dataIndex: "tipo_conta",
      key: "tipo_conta"
    },
    {
      title: "Ações",
      key: "actions",
      render: (text, record) => (
        <span>
          <Divider type="vertical" />
          <Button
            onClick={event => this.handleEditPerson(record)}
            type="primary"
          >
            edit
          </Button>

          <Button
            onClick={event => this.handleViewPerson(record)}
            type="danger"
          >
            delete
          </Button>
        </span>
      )
    }
  ];

  handleViewPerson = record => {
    this.setState({
      ...this.state,
      pessoa: record,
      visible: true,
      disabled: true
    });
  };
  handleEditPerson = record => {
    this.setState({
      ...this.state,
      pessoa: record,
      visible: true,
      disabled: false
    });
  };

  handleOnClick = async e => {
    //e.preventDefault()
    this.setState({ ...this.state, tableLoading: true });
    const search = document.getElementById("search").defaultValue;
    this.search = search;
    let data = await this.getPessoas();
    let dataSource = this.handleAPIResponse(data);
    this.setState({
      tableLoading: false,
      dataSource: dataSource,
      total: data.data.count
    });
  };

  onChange = async e => {
    this.setState({ ...this.state, tableLoading: true });
    this.page = e;
    let data = await this.getPessoas();
    let dataSource = this.handleAPIResponse(data);
    this.setState({
      tableLoading: false,
      dataSource: dataSource,
      total: data.data.count
    });
  };

  render() {
    const modal = this.state.visible == true ? this.getModal() : "";

    return (
      <div>
        <Card title="Pessoas" style={{ marginTop: "2.5%" }}>
          <Card style={{ marginTop: "30px" }}>
            <Table
              columns={this.columns}
              dataSource={this.state.dataSource}
              loading={this.state.tableLoading}
              pagination={{
                total: this.state.total,
                pageSize: 1000,
                onChange: e => this.onChange(e)
              }}
            />
          </Card>
        </Card>
        {modal}
      </div>
    );
  }

  handleCloseModal = e => {
    this.setState({ visible: false });
  };

  handleOnSubmit = async e => {
    e.preventDefault();
    let params = {
      id: this.state.pessoa.id,
      username: document.getElementById("username").value,
      password: document.getElementById("password").value,
      tipo_conta: this.state.pessoa.tipo_conta
    };
    try {
      const res = await api.put(`/conta-hdi/${params.id}/`, params, {
        headers: { "content-type": "application/json" }
      });
      message.success("Conta atualizada com sucesso");
    } catch (err) {
      message.error("Houve um erro " + err);
      console.log(err);
    }

    this.setState({
      ...this.state,
      visible: false
    });
  };

  setTipo = value => {
    let pessoa = this.state.pessoa;
    pessoa.tipo_conta = value;
    let new_state = this.state;
    new_state.pessoa = pessoa;
    this.setState(new_state);
  };

  getModal() {
    const pessoa = this.state.pessoa;
    return (
      <Modal
        title="Pessoa"
        visible={this.state.visible}
        closabe={true}
        destroyOnClose={true}
        onCancel={this.handleCloseModal}
        afterClose={this.handleCloseModal}
        footer={[]}
      >
        <Card>
          <Form onSubmit={e => this.handleOnSubmit(e)}>
            <Form.Item label="Username">
              <Input
                placeholder="Username"
                disabled={this.state.disabled}
                id="username"
                defaultValue={pessoa.username == null ? "" : pessoa.username}
              />
            </Form.Item>
            <Form.Item label="Passowrd">
              <Input
                placeholder="password"
                disabled={this.state.disabled}
                id="password"
                defaultValue={pessoa.password == null ? "" : pessoa.password}
              />
            </Form.Item>
            <Form.Item label="Tipo">
              <Select
                placeholder="Tipo"
                disabled={this.state.disabled}
                id="tipo_conta"
                defaultValue={
                  pessoa.tipo_conta == null ? "" : pessoa.tipo_conta
                }
                onChange={this.setTipo}
              >
                <Select.Option value="amigavel">amigavel</Select.Option>
                <Select.Option value="judicial">judicial</Select.Option>
              </Select>
            </Form.Item>
            <Button
              htmlType="submit"
              type="primary"
              disabled={this.state.disabled}
            >
              Salvar
            </Button>
          </Form>
        </Card>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/ContaHDI/index.js